import z from 'zod';

export const boardMemberSchema = z.object({
  accountId: z.string(),
  name: z.string(),
  email: z.string(),
});

export type BoardMember = z.infer<typeof boardMemberSchema>;
